import { useQuery } from "@tanstack/react-query";

import { getFullPopup } from "services";

import { DEFAULT_CACHE_TIME, GET_FULL_POPUP } from "consts";

import { FullPopup } from "models";

export const useGetFullPopup = ({ language, type }: { language: string; type: string }) => {
  const { data, isLoading } = useQuery<FullPopup>({
    queryKey: [GET_FULL_POPUP, type, language],
    queryFn: ({ signal }) => getFullPopup({ signal, language, type }),
    gcTime: DEFAULT_CACHE_TIME * 7,
    staleTime: DEFAULT_CACHE_TIME * 7,
  });

  return { popup: data || null, popupIsLoading: isLoading };
};
